"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_audio_player_1 = __importDefault(require("react-audio-player"));
const react_timeago_1 = __importDefault(require("react-timeago"));
const AspectRatioBox_1 = __importDefault(require("components/base/AspectRatioBox"));
const Card_1 = require("components/base/Card");
const Layout_1 = require("components/base/Layout");
const Link_1 = __importDefault(require("components/base/Link"));
const Text_1 = __importDefault(require("components/base/Text"));
const CommentsSection_1 = __importDefault(require("components/comments/CommentsSection"));
const DynamicFlash_1 = __importDefault(require("components/DynamicFlash"));
const RenderToRoot_1 = __importDefault(require("components/RenderToRoot"));
const MainLayout_1 = __importDefault(require("layouts/MainLayout"));
const PodcastEpisodePage = ({ loginCallback = '/', episode }) => {
    return (react_1.default.createElement(MainLayout_1.default, { loginCallback: loginCallback },
        react_1.default.createElement(DynamicFlash_1.default, null),
        react_1.default.createElement(Card_1.Card, { className: "my-3" },
            react_1.default.createElement(Card_1.CardHeader, null,
                react_1.default.createElement(Layout_1.Flexbox, { direction: "col", gap: "2", alignItems: "start" },
                    react_1.default.createElement(Text_1.default, { semibold: true, lg: true }, episode.title),
                    react_1.default.createElement(Text_1.default, { semibold: true, sm: true },
                        "from ",
                        react_1.default.createElement(Link_1.default, { href: `/content/podcast/${episode.podcast}` }, episode.podcastName),
                        ' - ',
                        react_1.default.createElement(react_timeago_1.default, { date: episode.date })))),
            react_1.default.createElement(Layout_1.Row, { className: "g-0" },
                react_1.default.createElement(Layout_1.Col, { xs: 12, sm: 4, className: "pe-0" },
                    react_1.default.createElement(AspectRatioBox_1.default, { ratio: 1, className: "text-ellipsis" },
                        react_1.default.createElement("img", { className: "w-full", alt: episode.title, src: episode.image }))),
                react_1.default.createElement(Layout_1.Col, { xs: 12, sm: 8, className: "border-start ps-0" },
                    react_1.default.createElement(Card_1.CardBody, null,
                        react_1.default.createElement(react_audio_player_1.default, { src: episode.url, controls: true, className: "w-full" })),
                    react_1.default.createElement(Card_1.CardBody, { className: "border-top" },
                        react_1.default.createElement("div", { dangerouslySetInnerHTML: { __html: episode.body || '' } })))),
            react_1.default.createElement("div", { className: "border-top" },
                react_1.default.createElement(CommentsSection_1.default, { parentType: "episode", parent: episode.id, collapse: false })))));
};
exports.default = (0, RenderToRoot_1.default)(PodcastEpisodePage);
